/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationDto } from '../../models/validation-dto';

export interface ContractValidateAdmissionDate$Params {
  admissionPlannedDate?: string;
}

export function contractValidateAdmissionDate(http: HttpClient, rootUrl: string, params?: ContractValidateAdmissionDate$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationDto>> {
  const rb = new RequestBuilder(rootUrl, contractValidateAdmissionDate.PATH, 'get');
  if (params) {
    rb.query('admissionPlannedDate', params.admissionPlannedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ValidationDto>;
    })
  );
}

contractValidateAdmissionDate.PATH = '/v1/Contract/ValidateAdmissionDate';
